import { dubaiTodayStr, datePart, dayLabel, addDays } from "@/utils/dubaiDay";

// Overdue first (most overdue on top), then one group per Dubai day in the window.
export function groupOpenSuggestions(rows, todayStr = dubaiTodayStr()) {
  const isLapsed = (r) => (r.flags || []).includes("LAPSED");
  const lapsed = rows
    .filter(isLapsed)
    .sort((a, b) => (b.daysOverdue || 0) - (a.daysOverdue || 0));
  const overdue = rows
    .filter((r) => r.overdue && !isLapsed(r))
    .sort((a, b) => (b.daysOverdue || 0) - (a.daysOverdue || 0));
  const byDay = new Map();
  rows.filter((r) => !r.overdue && !isLapsed(r)).forEach((r) => {
    const day = datePart(r.suggestedDate);
    if (!byDay.has(day)) byDay.set(day, []);
    byDay.get(day).push(r);
  });
  const tomorrow = addDays(todayStr, 1);
  const days = [...byDay.keys()].sort().map((day) => ({
    day,
    label: day === todayStr ? "Today" : day === tomorrow ? "Tomorrow" : dayLabel(day),
    items: byDay.get(day).sort((a, b) => (a.supplierName || "").localeCompare(b.supplierName || "")),
  }));
  return { overdue, days, lapsed };
}

export const pointLabel = (r) => (r.locationName ? `${r.supplierName} / ${r.locationName}` : r.supplierName);

export const confidenceClass = (c) =>
  ({
    high: "bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300",
    medium: "bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300",
    low: "bg-neutral-100 text-neutral-600 dark:bg-neutral-700 dark:text-neutral-300",
  }[c] || "bg-neutral-100 text-neutral-600");

const FLAG_LABELS = {
  OVERDUE: "Overdue",
  LAPSED: "Lapsed",
  VOLUME_DECLINING: "Volume declining",
  VOLUME_RISING: "Volume rising",
  POSSIBLY_LOST: "Possibly lost",
  PREFERRED_WEEKDAY: "Usual weekday",
  STALE_OPEN_REQUEST: "Stale open request",
  RECENTLY_DISMISSED: "Recently dismissed",
};
export const flagLabel = (f) => FLAG_LABELS[f] || f;
export const flagClass = (f) =>
  f === "POSSIBLY_LOST" || f === "OVERDUE" || f === "LAPSED"
    ? "bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300"
    : "bg-neutral-100 text-neutral-600 dark:bg-neutral-700 dark:text-neutral-300";
